export function mountDeparturesLazy(el: Element, mount: () => void): void {
  let io: IntersectionObserver | null = null;

  const trigger = (): void => {
    if (io) {
      io.disconnect();
      io = null;
    }
    mount();
  };

  // Trigger 1: hash already targets the section on page load
  if (window.location.hash === '#tour-departures') {
    trigger();
    return;
  }

  // Trigger 2: viewport proximity
  if (typeof IntersectionObserver === 'undefined') {
    // Fallback for very old browsers: mount immediately
    trigger();
    return;
  }

  io = new IntersectionObserver(
    (entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        trigger();
      }
    },
    { root: null, rootMargin: '500px', threshold: 0 }
  );

  io.observe(el);

  // Trigger 3: user intent via click on any #tour-departures anchor
  document.addEventListener('click', (e) => {
    const a = (e.target as HTMLElement)?.closest?.('a[href*="#tour-departures"]') as HTMLAnchorElement | null;
    if (a) {
      trigger();
    }
  });
}
